module.exports = __webpack_public_path__ + "img/g1-ActiveDetail.ebc850bf.png";